
import colors from '../colors.json';

export default {
  inheritAttrs: false,
  props: {
    value: {
      type: [Boolean, Array],
      default: false
    },

    indeterminate: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    truncate: {
      type: Boolean,
      default: false
    },

    /**
     * @values colors
     */
    color: {
      /** @type {AlturaColors} */
      type: String,
      validator: val => colors.includes(val),
      default: 'primary-500'
    },

    name: {
      type: null,
      default: undefined
    }
  },

  data () {
    return { internalValue: this.value };
  },

  computed: {
    selected () {
      if (Array.isArray(this.internalValue)) { return this.internalValue.includes(this.name); }

      return this.internalValue;
    }
  },

  watch: {
    value () {
      this.internalValue = this.value;
    }
  },

  methods: {
    toggle () {
      if (this.disabled) { return; }

      if (this.indeterminate) { this.$emit('update:indeterminate', false); }

      if (Array.isArray(this.internalValue)) {
        const index = this.internalValue.indexOf(this.name);
        if (index >= 0) { this.internalValue.splice(index, 1); } else { this.internalValue.push(this.name); }
        this.$emit('input', this.internalValue);
        return;
      }

      this.internalValue = !this.internalValue;
      this.$emit('input', this.internalValue);
    },

    click () {
      this.toggle();
    }
  }
};
